<template>
  <div class="home no-select">
    <img alt="SkillSync logo" src="../assets/logo.png" />
    <AssessmentSearch
      v-if="!assessmentStarted"
      @assessment-started="handleAssessmentStarted"
    />
    <AssessmentUI
      v-if="assessmentStarted"
    />
  </div>
</template>
<script>
import AssessmentSearch from '@/components/CandidateAssessment/AssessmentSearch.vue'
import AssessmentUI from '@/components/CandidateAssessment/AssessmentUI.vue'

export default {
  name: 'CandidateAssessmentView',
  components: {
    AssessmentSearch,
    AssessmentUI
  },
  data() {
    return {
      assessmentStarted: false
    }
  },
  methods: {
    handleAssessmentStarted() {
      this.assessmentStarted = true;
    }
  }
}
</script>
<style scoped>
.home {
  margin: 0;
  padding: 0;
  background-image: url("../assets/candidate-assessment-background.png"); /* Replace 'path/to/your/image.jpg' with the path to your image */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.dashboard {
  margin: 0;
  padding: 0;
  background-color: #181a1b;
}

.no-select {
  user-select: none; /* Standard syntax */
  -webkit-touch-callout: none; /* iOS Safari */
}
</style>
